// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"35":"a78cd966","472":"3a6520bb","561":"e9c1c100","851":"caa79687"}[chunkId] + ".chunk.css";
};